import { PagePost } from "@gettactic/api";
import { cn } from "@gettactic/helpers";
import { PageCardGrid } from "./PageCardGrid";

export const PageCard = ({
  page,
  onClick
}: {
  page: PagePost;
  onClick: () => void;
}) => {
  const isPageClickable = (page: PagePost) => {
    return page.content && page.content.length > 0;
  };

  const clickable = isPageClickable(page);

  return (
    <div
      key={page.id}
      className={cn(
        "flex h-full flex-col overflow-hidden rounded-lg border border-neutral-200 shadow-sm transition-shadow duration-200",
        clickable ? "cursor-pointer hover:shadow-md" : "opacity-75"
      )}
      onClick={clickable ? onClick : undefined}
    >
      {/* <div className='h-24 overflow-hidden bg-neutral-100'>
        <img
          src={PLACEHOLDER_IMAGE}
          alt={page.title}
          className='h-full w-full bg-neutral-50 object-cover'
        />
      </div> */}
      <div className="flex flex-grow flex-col p-4">
        <h2
          className="line-clamp-2 font-bold text-sm"
          style={{ wordBreak: "break-word", maxWidth: "100%" }}
        >
          {page.title}
        </h2>
      </div>
    </div>
  );
};

export const PageGrid = ({
  pages,
  onPageClick
}: {
  pages: PagePost[];
  onPageClick: (page: PagePost) => void;
}) => {
  if (!pages || pages.length === 0) return null;

  return (
    <PageCardGrid>
      {pages.map((page) => (
        <PageCard key={page.id} page={page} onClick={() => onPageClick(page)} />
      ))}
    </PageCardGrid>
  );
};
